import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { useCart } from "@/contexts/CartContext";

const CartButton = () => {
  const { count } = useCart();

  return (
    <Link
      to="/cart"
      aria-label={count > 0 ? `Cart, ${count} item${count > 1 ? "s" : ""}` : "Cart, empty"}
      className="relative flex items-center justify-center w-10 h-10 rounded-full border border-primary/40 text-primary hover:bg-primary/10 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
    >
      <ShoppingCart className="w-5 h-5" />
      {count > 0 && (
        <span
          aria-hidden="true"
          className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-primary text-primary-foreground font-heading text-[10px] font-bold leading-none"
        >
          {count > 9 ? "9+" : count}
        </span>
      )}
    </Link>
  );
};

export default CartButton;
